



















































































import { Vue, Component } from "vue-property-decorator";
import ProductDetail from "@/components/cutomer/productDetail.vue";
import QPaginate from "@/common/qPaginate.vue";
import productApi from "@/api/productApi";
import PaginateModel from "@/model/paginate";
import Product, { Category } from "@/model/product";
import categoryApi from "@/api/categoryApi";
import QProductPopup from "@/common/qProductPopup.vue";
import { namespace } from "vuex-class";
const cartStore = namespace("Cart");
const authStore = namespace("Auth");
@Component({
  name: "CustomerHome",
  components: {
    ProductDetail,
    QPaginate,
    QProductPopup,
  },
})
export default class CustomerHome extends Vue {
  @cartStore.Getter
  cartItems!: any[];

  @authStore.Getter
  getUserType!: string;

  public categories: Category[] = [];
  public pagination = new PaginateModel({
    page: 0,
    pageCount: 0,
    start: 0,
    end: 0,
    count: 0,
  });
  public products: Product[] = [];
  public search = {
    item_code: "",
    item_name_1: "",
    item_name_2: "",
    cart_cate_code: null,
  };

  async mounted() {
    this.getCategories();
    this.initalSearch(null);
  }

  public async getCategories() {
    this.categories = await categoryApi.all({
      all: true,
    });
  }

  public async doSearch(query: any) {
    const result = await productApi.getAll({ ...query, is_publish: true });

    this.pagination = result.paginate;
    this.products = result.list;
  }

  public changeState(): void {
    let { name, params, query } = this.$router.currentRoute;

    query = { ...query, ...this.search };

    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
  }

  public initalSearch(parameters: any): void {
    const query = parameters || this.$router.currentRoute.query;
    if (query.status) {
      query.status = query.status.map((item) => Number.parseInt(item));
    }
    this.search = {
      item_code: "",
      item_name_1: "",
      item_name_2: "",
      cart_cate_code: null,
      ...query,
    };
    this.doSearch(this.search);
  }

  public filter(clear = false, addition = {}): void {
    let { name, params, query } = this.$router.currentRoute;
    query = { ...query, ...this.search, ...addition };
    if (clear) {
      query = {};
    }
    this.$router
      .replace({ name: name, params: params, query })
      .catch((error) => {
        console.error(error);
      });
    this.doSearch(query);
  }

  public resetSearch() {
    this.search = {
      item_code: "",
      item_name_1: "",
      item_name_2: "",
      cart_cate_code: null,
    };
    this.filter(true);
  }

  public showDetail(product: Product) {
    (this.$refs.productPopup as QProductPopup).show(product);
  }
}
